<div class="d-flex gap-7">
  <div *ngIf="diffType === 'modified'" class="mw-40">{{ type | uppercase }}:</div>
  <div class="d-flex flex-wrap gap-7" [ngClass]="type === 'old' ? 'red-color' : 'dark-green-color'">
    <div class="d-flex gap-3 mw-80">
      <span [appTooltip]="{airportCode: flight.departure?.airportCode, terminalName: flight.departure?.terminalName}">
        {{ flight.departure.airportCode }}
      </span>
      <span>→</span>
      <span [appTooltip]="{airportCode: flight.arrival?.airportCode, terminalName: flight.arrival?.terminalName}">
        {{ flight.arrival.airportCode }}
      </span>
    </div>

    <span class="d-flex gap-3">
      <span [class.fw-500]="diffs?.includes('departure.date')">{{ (flight.departure.date | dateFormat) | async }}</span>
      <span [class.fw-500]="diffs?.includes('departure.time')">{{ flight.departure.time }}</span> -
      <span [class.fw-500]="diffs?.includes('arrival.date')">{{ (flight.arrival.date | dateFormat) | async }}</span>
      <span [class.fw-500]="diffs?.includes('arrival.time')">{{ flight.arrival.time }}</span>
    </span>

    <span *ngIf="flight.flightNumber" [class.fw-500]="diffs?.includes('flight_number')">
      {{ flight.flightNumber }}
    </span>

    <span *ngIf="flight?.cabinDesignator" class="mw-80" [class.fw-500]="diffs?.includes('cabin_designator')">
      {{ flight.cabinDesignator }}
    </span>

    <span *ngIf="flight?.classCode" class="mw-24" [class.fw-500]="diffs?.includes('class_code')">
      {{ flight.classCode }}
    </span>

    <span *ngIf="flight?.aircraftCode" class="mw-30" [class.fw-500]="diffs?.includes('aircraft_code')">
      {{ flight.aircraftCode }}
    </span>

    <span *ngIf="flight?.status" [class.fw-500]="diffs?.includes('status')">
      {{ flight.status }}
    </span>
  </div>
</div>
